import { render, staticRenderFns } from "./TreatmentStartedTimelineSection.vue?vue&type=template&id=70439899&scoped=true"
import script from "./TreatmentStartedTimelineSection.vue?vue&type=script&lang=js"
export * from "./TreatmentStartedTimelineSection.vue?vue&type=script&lang=js"
import style0 from "./TreatmentStartedTimelineSection.vue?vue&type=style&index=0&id=70439899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70439899",
  null
  
)

export default component.exports